// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"08c43b84","726":"77dad95b","775":"0a64f100","868":"d4f0f383"}[chunkId] + ".chunk.js";
};